// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xj_a bhf_a bhf_x","StrollerDetailRating__muted":"xj_b bhf_fm"};